module.exports = __webpack_public_path__ + "static/media/git-gud.62cf1b4a.png";